import React, { Component } from 'react';
import AcctRouter from './AcctMgt/router'
import FtpRouter from './FTPMgt/router'
import ChangePassword from './AcctMgt/component/ChangePassword'
import './css/App.css'

import { BrowserRouter as Router, Route, Switch} from "react-router-dom";

class App extends Component {

  render() {


    return (
      <div className="App">

      <Router basename='custom'>
      <Switch>
        <Route path="/acctMgt" component={AcctRouter} />
        <Route path='/ftpMgt' component={FtpRouter} />
        <Route path='/changepassword' component={ChangePassword} />
      </Switch>
     
      </Router>

      </div>
     );
  }
}


export default App
